import {AfterViewInit, Component, OnInit} from '@angular/core';
import {NgxSmartModalService} from "ngx-smart-modal";
import moment from "moment";

@Component({
  selector: 'evrideo-choose-day-and-time',
  templateUrl: './choose-day-and-time.component.html',
  styleUrl: './choose-day-and-time.component.scss'
})
export class ChooseDayAndTimeComponent implements OnInit {
  vm: ChooseDayAndTimeViewModel;
  constructor(
    private _ngxSmartModalService: NgxSmartModalService
  ) {
  }

  ngOnInit(): void {
    this._ngxSmartModalService
      .getModal("chooseDayAndTimePromptModal")
      .onDataAdded.subscribe((vm: ChooseDayAndTimeViewModel) => {
      this.vm = vm;
    });
  }

}

export class ChooseDayAndTimeViewModel {
  constructor(
    public dayOfWeek: number,
    public selectedTimeInMinutes: number,
    public onApplyClickedHandler: ($this: ChooseDayAndTimeViewModel) => void
  ) {
  }

  public reset(): void {
    this.dayOfWeek = 0;
    this.selectedTimeInMinutes = 0;
  }

  public init(): void {
    this.reset();
  }
}
